<template>
  <div class="all-time-stats">
    <div class="target-section">
      <span class="stat-value">{{ completed }}</span>
      <span class="stat-target">/ {{ target }}</span>
      <p class="stat-caption">
        Completed Registrations
      </p>
    </div>
    <el-progress x-type="circle" :percentage="progress" />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { sortBy } from 'lodash'
import { ref, computed } from '@vue/composition-api'

export default {
  props: [],
  setup({}) {
    return {
      progress: 74,
      completed: 37,
      target: 50,
    }
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';
@import '~assets/css/vars.scss';

.all-time-stats {
  color: $grey120;

  .target-section {
    .stat-value {
      font-size: 30px;
      font-weight: 300;
    }
    .stat-target {
      font-size: 12px;
    }
    .stat-caption {
      font-size: 12px;
    }
  }
}
</style>
